import { useFlags } from '@equipmentshare/feature-flags'
import LegacyToasts from './LegacyToasts'
import MuiToasts from './MuiToasts'

export default function Toasts() {
	const flags = useFlags()

	return flags.costentoryEnableMuiToasts ? <MuiToasts /> : <LegacyToasts />
}
